import React, { Component } from 'react'
import trans from "trans"
import DynamicTextShape from "../types/DynamicTextShape";
import RenderText from "../render-text";
import { GradientDefs } from "shape-edit/forms/fields";
import { getBackgroundObjectByShape } from 'template-edit/components/helper';
import { SizeType } from 'products/components/filters';
import { EditModeType } from 'app/types/app-types';

const { round } = Math

interface Props {
    data: DynamicTextShape
    activeShapeId: string
    updateShape: Function
    editMode: EditModeType
}

interface State {
    newSize: SizeType
}

class DynamicTextSvg extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            newSize: null,
        }
    }

    setRealSize = (newSize: SizeType) => {
        this.setState({newSize: newSize})
    }

    render() {
        const { newSize } = this.state
        const { data } = this.props

        const scale = data.scale && data.scale !== 0 ? data.scale : 1
        const isShadow = data.shadow_color && data.shadow_sigma
        const backgroundObject = getBackgroundObjectByShape(data, newSize)

        const content: any = data.text_content ? data.text_content : trans("empty_element")
        const h = round(data.text_fontsize / scale)

        return (
            <g className="draggable dynamic" width={data.width} height={data.height}>
                {isShadow &&
                    <filter id={`shadow-${data.index}`} width="200%" height="200%" y="-50%" x="-50%">
                        <feDropShadow
                            dx={data.shadow_xoffset}
                            dy={data.shadow_yoffset}
                            stdDeviation={data.shadow_sigma}
                            floodColor={data.shadow_color}
                            floodOpacity={1 - data.shadow_opacity / 100}
                        />
                    </filter>
                }

                {data.gradient_id && data.gradient &&
                    <GradientDefs gradient={data.gradient} idx={data.gradient_id} />
                }

                {backgroundObject}

                <RenderText
                    shape={data}
                    fontSize={h}
                    width={data.width}
                    h={data.height}
                    setRealSize={this.setRealSize}
                    offsetY={0}
                    activeShapeId={this.props.activeShapeId}
                    editMode={this.props.editMode}
                />
            </g>
        )
    }
}

export default DynamicTextSvg
